import { Rest } from 'utilities/rest';
import * as ActionCreator from 'utilities/action.creator';
import { $failure, $requesting, $success } from '../form/action';
import { $processing, $done } from 'services/activity/action';

export const MODULE = 'Payment';

const API_URL = `${process.env.REACT_APP_SERVICE_SYSTEM_URL}`;

export const $reset = ActionCreator.Default(MODULE, 'reset', () =>
  $reset.action()
);

export const $create = ActionCreator.Async(MODULE, 'Create', (id, payload) => {
  return async (dispatch) => {
    dispatch($requesting.action());

    return await Rest.POST(`${API_URL}/tms/delivery/payment/${id}`, payload)
      .then((response) => {
        dispatch($create.success({ response: response }));
        dispatch($success.action());
        return response;
      })
      .catch((error) => {
        dispatch($failure({ error }));
        return false;
      });
  };
});

export const $update = ActionCreator.Async(
  MODULE,
  'Update',
  (id, payment_id, payload) => {
    return async (dispatch) => {
      dispatch($requesting.action());

      return await Rest.PUT(
        `${API_URL}/tms/delivery/payment/${id}/update/${payment_id}`,
        payload
      )
        .then((response) => {
          dispatch($update.success({ response: response?.data }));
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          dispatch($failure({ error }));
          return false;
        });
    };
  }
);

export const $delete = ActionCreator.Async(
  MODULE,
  'Delete',
  (id, payment_id) => {
    return async (dispatch) => {
      dispatch($processing($delete.OPERATION));

      return await Rest.PUT(
        `${API_URL}/tms/delivery/payment/${id}/delete/${payment_id}`
      )
        .then((response) => {
          dispatch($success.action());
          return response;
        })
        .catch((error) => {
          return false;
        })
        .finally(() => dispatch($done($delete.OPERATION)));
    };
  }
);

export const $getByOrder = ActionCreator.Async(MODULE, 'GetByOrder', (id) => {
  return async (dispatch) => {
    dispatch($processing($getByOrder.OPERATION));

    return await Rest.GET(`${API_URL}/tms/delivery/payment/${id}/order`)
      .then((response) => {
        dispatch($getByOrder.success({ response: response?.data }));
        return response;
      })
      .catch((error) => {
        return false;
      })
      .finally(() => dispatch($done($getByOrder.OPERATION)));
  };
});